var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupMe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.239 2H8.772C5.584 2 3 4.57 3 7.739V21.131C3 24.3 5.584 26.87 8.772 26.87H11.676C12.514 26.87 12.894 26.94 13.292 27.168C13.729 27.418 13.973 28.078 14.216 28.734C14.52 29.558 14.823 30.378 15.506 30.378C16.162 30.378 16.467 29.611 16.784 28.817C17.058 28.127 17.341 27.417 17.869 27.168C18.296 26.967 18.617 26.87 19.365 26.87H22.239C25.427 26.87 28.011 24.3 28.011 21.131V7.739C28.011 4.57 25.427 2 22.239 2ZM15.475 22.634C12.035 22.634 8.831 20.941 6.904 18.103C6.577 17.622 6.705 16.968 7.189 16.643C7.674 16.317 8.331 16.445 8.658 16.927C10.191 19.181 12.74 20.53 15.475 20.53C18.21 20.53 20.76 19.181 22.296 16.923C22.623 16.442 23.28 16.314 23.764 16.64C24.248 16.965 24.377 17.618 24.05 18.1C22.119 20.941 18.916 22.634 15.475 22.634ZM20.286 7.91V9.823H18.363V11.736H20.286V13.649H18.363V15.562H16.439V13.649H14.515V15.562H12.591V13.649H10.667V11.736H12.591V9.823H10.667V7.91H12.591V5.996H14.515V7.91H16.439V5.996H18.363V7.91H20.286ZM14.515 11.736H16.439V9.823H14.515V11.736Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupMe);
export default __webpack_public_path__ + "static/media/group-me.92a0205e.svg";
export { ForwardRef as ReactComponent };